<template>
	<div>
		<error-dialog
			v-model="errorDialogOpen"
			:title="$_.get(error, 'name', 'error')"
			:message="$_.get(error, 'message', 'Unknown error occurred.')"
			persistent
		>
			<v-btn x-small :href="mailTo" text> send email </v-btn>
		</error-dialog>
		<v-snackbar :timeout="timeout" v-model="snackbarOpen" class="slightOpacity">
			<v-row>
				<v-col class="mr-0" cols="2" sm="2" md="2" lg="2" xl="2">
					<v-icon large>{{ $_.get(information, 'icon', 'mdi-message-question') }}</v-icon>
				</v-col>
				<v-col class="ml-0" cols="10" sm="10" md="10" lg="10" xl="10">
					<span class="d-block">
						<b>{{ $_.get(information, 'title', 'Information') }}</b>
					</span>
					<span class="d-block">{{ $_.get(information, 'message', 'Unknown information.') }}</span>
				</v-col>
			</v-row>
			<template v-slot:action="{ attrs }">
				<v-btn v-bind="attrs" @click="snackbarOpen = false" text> OK </v-btn>
			</template>
		</v-snackbar>
	</div>
</template>
<script>
import ErrorDialog from '@/components/base/ErrorDialog.vue';
// store
import { mapStores } from 'pinia';
import { useGlobalMessageStore } from '../../index';

export default {
	components: { ErrorDialog },
	name: 'GlobalMessages',
	data() {
		return {
			timeout: 4000,
		};
	},
	computed: {
		mailTo() {
			return `mailto:${window.__APP_CONFIG__.APP_SUPPORT_EMAIL}?subject=${
				window.__APP_CONFIG__.TITLE + ' - ' + this.errorTitle
			}&body=${JSON.stringify(this.error, null, 2)}`;
		},
		...mapStores(useGlobalMessageStore),
		error() {
			return this.globalMessagesStore.error.onDisplay;
		},
		errorDialogOpen: {
			get() {
				return !!this.globalMessagesStore.error.onDisplay;
			},
			set(value) {
				if (!value) this.globalMessagesStore.error.onDisplay = null;
			},
		},
		information() {
			return this.globalMessagesStore.information.onDisplay;
		},
		snackbarOpen: {
			get() {
				return !!this.globalMessagesStore.information.onDisplay;
			},
			set(value) {
				if (!value) this.globalMessagesStore.information.onDisplay = null;
			},
		},
	},
};
</script>
<style scoped>
.slightOpacity {
	opacity: 0.8;
}
</style>
